import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "left" }}>
            Hi Everyone, I am <span className="purple">Athmika U</span>{" "}
            from <span className="purple">Mangalore, India</span>.
            <br />
            I am passionate about <span className="purple">Full Stack Development</span>,{" "}
            problem solving, and building{" "}
            scalable, user-friendly applications. I love exploring{" "}
            <span className="purple">new technologies</span> and continuously{" "}
            improving my skills.  
            <br />
            <br />
            I am always open to <span className="purple">collaboration</span>{" "}
            and eager to hear <span className="purple">innovative ideas</span>{" "}
            that can lead to impactful projects. 
            <br />
            <br />
            Apart from coding, I also enjoy:
          </p>

          <ul>
            <li className="about-activity">
              <ImPointRight /> Sketching & Painting
            </li>
            <li className="about-activity">
              <ImPointRight /> Listening to Music
            </li>
            <li className="about-activity">
              <ImPointRight /> Solving Rubik's Cubes
            </li>
            <li className="about-activity">
              <ImPointRight /> Traveling & Exploring
            </li>
          </ul>

          {/* <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to create solutions that make an impact."
          </p>
          <footer className="blockquote-footer">Athmika</footer> */}
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
